import {Typography} from "@mui/material";

export const FinancialInfoContent = () => {


    return {
        title: 'Financials',
        content: (
            <>
                <Typography paragraph>
                    Financials contain the revenue, expense, and other
                    financial activity associated with the products
                    being administered by the system.
                </Typography>

                <ul>
                    <li>
                        Financial records can represent product-level,
                        contract-level, stakeholder-level, or other
                        financial transactions and adjustments.
                    </li>

                    <li>
                        Financial adjustments can be used to add,
                        reduce, or correct financial activity before
                        obligations are calculated.
                    </li>

                    <li>
                        Use the <strong>Search</strong> (magnifying glass)
                        to locate existing Financial records.
                    </li>

                    <li>
                        Use the <strong>Upload</strong> button to import
                        Financial data from external files.
                    </li>

                    <li>
                        Use the <strong>Add</strong> (+) button to create
                        a new Financial record manually.
                    </li>

                    <li>
                        Use the row menu on the left side of the grid
                        to clone, edit, or delete Financial records.
                    </li>

                    <li>
                        Financial files can also be
                        <strong> Processed</strong> from this screen
                        to calculate obligations and generate work
                        for contracts that are impacted by the
                        financial activity.
                    </li>

                    <li>
                        Accurate Financial data is critical because it
                        serves as the primary driver for many residual,
                        participation, royalty, and obligation
                        calculations throughout the system.
                    </li>
                </ul>
            </>
        )
    };
};






